module.exports = __webpack_public_path__ + "static/Roof Tiling - 2-c85c3b8b02d5eb4f5ffdc6f5b11e9ff0.jpg";